import isDomElement from 'utils/predicates/dom/isDomElement.util';

const fromOptionsToElement = (options) => {
  if (!options) return null;

  if (isDomElement(options.element)) return options.element;
  if (isDomElement(options.el)) return options.el;

  return null;
};

export default fromOptionsToElement;
